// The Election Admin Suite's address, for the 9-dot app switcher (2.1.1, suite task 68).
//
// The page needs the suite's address to tell switcher.js where to ask for the office's tools
// (data-api). Up to 2.0.3 the page took it from the suite sign-in or sign-out link, but a person
// signed in with Poll Worker Management (2.1.0) gets the relative "/signout/pwm" instead, so the
// switcher disappeared for them. The Worker now sends it as its own field, suiteOrigin, built
// from SUITE_URL whatever way the person signed in.
//
// Only what switcher.js itself accepts (its apiOrigin): https on electionadminsuite.com or a
// subdomain, no port; or http(s) localhost / 127.0.0.1 for local tests. Anything else gives null,
// and the page then shows no button (it could only say "Your tools didn't load"). The page
// (app/switcherLink.js) checks again with this same function.
const SUITE_HOST = /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)*electionadminsuite\.com$/;

export function suiteOriginOf(raw) {
  if (!raw || typeof raw !== "string" || !/^https?:\/\//i.test(raw.trim())) return null;
  let u;
  try { u = new URL(raw.trim()); } catch { return null; }
  if (u.username || u.password) return null;
  if (u.protocol === "https:" && !u.port && SUITE_HOST.test(u.hostname)) return u.origin;
  if (/^(localhost|127\.0\.0\.1)$/.test(u.hostname) && /^https?:$/.test(u.protocol)) return u.origin;
  return null;
}
